var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"artists",attrs:{"id":"artists-playlist"}},[_c('div',{staticClass:"m-t-nav"},[_c('div',{staticClass:"big-m-t"},[_c('Playlist',{key:_vm.reloadComponent,attrs:{"playlist-position":0,"playlist":_vm.profilesWorld,"listType":'profiles',"editButtons":false,"title":false,"subTitle":_vm.subTitle,"view":'list'}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }